<template>
  <div class="hotel-list">
    <div v-for="(item, i) in content.hotelListDate" :key="i" class="hotel-item">
      <div class="area">{{ item.area }}</div>
      <div class="hotel">{{ item.name }}</div>
      <div class="location">所在地 :{{ item.location }}</div>
      <div class="plan">プラン例:{{ item.plan }}</div>
    </div>
  </div>
</template>

<script>
import text from "@/assets/txt/free_stay.json";

var textDate = text;
export default {
  props: {},
  data() {
    return {
      content: textDate,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/freeStay/hotelList.scss";
</style>
